import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg className={styles["myhouse_setting_auth--arrow"] || "myhouse_setting_auth--arrow"} xmlns="http://www.w3.org/2000/svg" width="7" height="17" {...props}><path d="M.611 3.611a.552.552 0 01.702-.064l.076.064 4.5 4.5c.19.191.212.487.064.702l-.064.076-4.5 4.5a.55.55 0 01-.842-.702l.064-.076L4.723 8.5.611 4.389a.554.554 0 01-.064-.702l.064-.076z" fill="#9AA8C2" fillRule="nonzero" /></svg>);